export interface DashboardDataCompanyFields {
  entity: string;
  name: string;
  uuid: string;
  summary: {
    partners_count: number;
    environments_count: number;
    environments_with_instances_count: number;
    environments_with_instances_percent: number;
    instances_count: number;
    clients_count: number;
    users_count: number;
    unique_users_count: number;
    sessions_count: number;
    created_clients_in_period: {
      count: number;
      period_in_days: number;
      growth_in_period_percent: number;
    };
    created_users_in_period: {
      count: number;
      period_in_days: number;
      growth_in_period_percent: number;
    };
  };
  children: {
    partners: [
      {
        uuid: string;
        summary: {
          environments_count: number;
          clients_count: number;
        };
      }
    ];
  };
}

export interface DashboardDataCompanyPartnerFields {
  entity: string;
  name: string;
  uuid: string;
  summary: {
    environments_count: number;
    environments_with_instances_count: number;
    environments_with_instances_percent: number;
    instances_count: number;
    clients_count: number;
    users_count: number;
    unique_users_count: number;
    sessions_count: number;
  };
}

export interface PartnerDataGraph {
  timestamp: number;
  licenses: number;
  sessions: {
    max: number;
    avg: number;
  };
  vacancies: {
    max: number;
    avg: number;
  };
  instances: {
    max: number;
    avg: number;
  };
}

export interface PartnerDataGraphFields {
  metrics: PartnerDataGraph[];
}

export interface PartnerEnvironmentsCostGraph {
  timestamp: number;
  cost: string;
}

export interface PartnerEnvironmentsCostGraphFields {
  total: string;
  metrics: PartnerEnvironmentsCostGraph[];
}

export enum PeriodCountAccess {
  LAST_24_HOURS = '1d',
  LAST_48_HOURS = '2d',
  LAST_7_DAYS = '7d',
  LAST_15_DAYS = '15d',
  LAST_30_DAYS = '30d',
  LAST_60_DAYS = '60d',
  LAST_90_DAYS = '90d',
  LAST_180_DAYS = '180d',
}

export interface DashboardState {
  readonly companyDashboardData: DashboardDataCompanyFields;
  readonly companyDashboardPartnerData: DashboardDataCompanyPartnerFields;
  readonly isLoading: boolean;
  readonly partnerDataGraphFields: PartnerDataGraphFields;
  readonly periodFilterPartnerGraph: PeriodCountAccess;
  readonly periodFilterPartner: PeriodCountAccess;
  readonly isLoadingGraphs: boolean;
  readonly isLoadingHistory: boolean;
  readonly partnerEnvironmentsCostGraphFields: PartnerEnvironmentsCostGraphFields;
  readonly partnerEnvironmentsCostPeriodFilter: PeriodCountAccess;
  readonly partnerEnvironmentsCostIsLoading: boolean;
}
